import {
  ActionsPayload,
  NodePayload,
  ActionProxyPayload,
  GetActionsProxyPayload,
  CreateActionProxyPayload,
  UpdateActionProxyPayload,
  AttachActionsProxyPayload,
  GetAllActionsProxyPayload,
} from "./index.d";
import {apiClient} from "@/utils/apiClient";

export const createFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = "/nodes";
  return apiClient(endpoint, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id}`;
  const method = "GET";

  return apiClient(endpoint, {
    method: method,
  });
};

export const editFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id || payload.node_id}`;
  const method = "PUT";

  return apiClient(endpoint, {
    method: method,
    body: JSON.stringify(payload),
  });
};

// Assistant actions
export const getNodeActions = async (payload: ActionsPayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id}/actions?action_type=${payload.action_type}&node_id=${payload.model_id}`;
  const method = "GET";

  return apiClient(endpoint, {
    method: method,
  });
};

// Actions Proxy Endpoints for Flow Designer

// Create action
export const createActionProxy = async (
  payload: CreateActionProxyPayload,
): Promise<any> => {
  const endpoint = `/nodes/${payload.node_id}/actions_proxy`;
  return apiClient(endpoint, {
    method: "POST",
    body: JSON.stringify(payload.data),
  });
};

// Get all actions for a node
export const getActionsProxy = async (
  payload: GetActionsProxyPayload,
): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (payload.workspace_id)
    queryParams.append("workspace_id", payload.workspace_id);
  if (payload.page_size)
    queryParams.append("page_size", payload.page_size.toString());
  if (payload.page_number)
    queryParams.append("page_number", payload.page_number.toString());
  if (payload.action_type)
    queryParams.append("action_type", payload.action_type);

  const queryString = queryParams.toString();
  const endpoint = `/nodes/${payload.node_id}/actions_proxy${queryString ? `?${queryString}` : ""}`;

  return apiClient(endpoint, {
    method: "GET",
  });
};

// Get specific action
export const getActionProxy = async (
  payload: ActionProxyPayload,
): Promise<any> => {
  if (!payload.action_id) {
    throw new Error("action_id is required for getActionProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}`;
  return apiClient(endpoint, {
    method: "GET",
  });
};

// Update action
export const updateActionProxy = async (
  payload: UpdateActionProxyPayload,
): Promise<any> => {
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}`;
  return apiClient(endpoint, {
    method: "PATCH",
    body: JSON.stringify(payload.data),
  });
};

// Delete action
export const deleteActionProxy = async (
  payload: ActionProxyPayload,
): Promise<any> => {
  if (!payload.action_id) {
    throw new Error("action_id is required for deleteActionProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}`;
  return apiClient(endpoint, {
    method: "DELETE",
  });
};

// Attach action
export const attachActionProxy = async (
  payload: ActionProxyPayload,
): Promise<any> => {
  if (!payload.action_id) {
    throw new Error("action_id is required for attachActionProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}/attach`;
  return apiClient(endpoint, {
    method: "POST",
    body: JSON.stringify(payload.data),
  });
};

// Attach actions in bulk
export const attachActionsProxy = async (
  payload: AttachActionsProxyPayload,
): Promise<any> => {
  if (!payload.actions) {
    throw new Error("actions is required for attachActionsProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/actions/attach`;
  return apiClient(endpoint, {
    method: "PATCH",
    body: JSON.stringify({
      actions: payload.actions,
      model_id: payload.node_id,
    }),
  });
};

// Detach action
export const detachActionProxy = async (
  payload: ActionProxyPayload,
): Promise<any> => {
  if (!payload.action_id) {
    throw new Error("action_id is required for detachActionProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}/detach`;
  return apiClient(endpoint, {
    method: "POST",
    body: JSON.stringify(payload.data),
  });
};

// Detach actions in bulk
export const detachActionsProxy = async (
  payload: AttachActionsProxyPayload,
): Promise<any> => {
  if (!payload.actions) {
    throw new Error("actions is required for detachActionsProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/actions/detach`;
  return apiClient(endpoint, {
    method: "PATCH",
    body: JSON.stringify({
      actions: payload.actions,
      model_id: payload.node_id,
    }),
  });
};

// Get all actions
export const getAllActionsProxy = async (
  payload: GetAllActionsProxyPayload,
): Promise<any> => {
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/actions/attach?action_type=${payload.action_type}&attachment_type=${payload.attachment_type}&page_number=1&page_size=99`;
  return apiClient(endpoint, {
    method: "GET",
  });
};
// Initialize action
export const initializeActionProxy = async (
  payload: ActionProxyPayload,
): Promise<any> => {
  if (!payload.action_id) {
    throw new Error("action_id is required for initializeActionProxy");
  }
  const endpoint = `/nodes/${payload.node_id}/actions_proxy/${payload.action_id}/initialize`;
  return apiClient(endpoint, {
    method: "POST",
  });
};
